import React, { useState } from 'react'
import { 
  Avatar, 
  Box, 
  Paper, 
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableHead, 
  TableRow, 
  Typography,
  TablePagination
} from '@mui/material'
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  tableContainer: {
    padding: 0,
    border: "2px solid #E8E8E8",
    borderRadius: "10px"
  },
  status: {
    borderRadius: "20px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "5px"
  },
  tableHeader: {
    background: "#3E4094", 
    color: "#fff",
    whiteSpace: "nowrap"
  }
}));

const CommonDataTable = ({ 
  tableData, 
  viewHandler, 
  tableHeaders, 
  tableDataKey, 
  viewText, 
  centerHeadCell, 
  centerBodyCell, 
  profileKeys,
  pagination 
}) => {
  const { classes } = useStyles();
  
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const paginatedData = tableData.slice(
    page * rowsPerPage, 
    page * rowsPerPage + rowsPerPage
  );

  return (
    <>
      <TableContainer component={Paper} elevation={0} className={classes.tableContainer}>
        <Table aria-label="order table">
          <TableHead>
            <TableRow sx={classes.tableHeader}>
              {tableHeaders.map((item, i) => (
                <TableCell 
                  key={item}
                  sx={{ 
                    color: "#fff",
                    fontSize: {lg : "20px", md: "15px"}, 
                    fontWeight: {lg: "bold", md: "medium"}, 
                    textAlign: centerHeadCell?.includes(i) ? "center" : "start" 
                  }}
                >
                  {item}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {(pagination ? paginatedData : tableData).map((data, rowIndex) => (
              <TableRow key={rowIndex} sx={{whiteSpace: "nowrap"}}>
                <>
                  {profileKeys && (
                    <TableCell sx={{ fontSize: {lg: "18px", md: "14px"}, display: "flex", alignItems: "center", gap: "8px" }}>
                      <Avatar
                        src={data[profileKeys[0]] || "images/Avatar.svg"}
                        sx={{ width: {lg: 40, md: 30}, height: {lg: 40, md: 30} }}
                        alt="User profile avatar"
                      />
                      {data[profileKeys[1]]}
                    </TableCell>
                  )}
                  {tableDataKey.map((key, i) => (
                    key === "status" ? (
                      <TableCell key={key} sx={{ fontSize: {lg: "18px", md: "14px"} }}>
                        <Box
                          className={classes.status}
                          sx={{
                            textAlign: centerBodyCell?.includes(i) ? "center" : "start",
                            background: data.status === "pending" ? "#F8D270"
                              : data.status === "rejected" ? "#ff5b5b"
                                : "#53e853"
                          }}
                        >
                          {data.status}
                        </Box>
                      </TableCell>
                    ) : (
                      <TableCell 
                        key={key} 
                        sx={{ 
                          fontSize: {lg: "18px", md: "14px"}, 
                          textAlign: centerBodyCell?.includes(i) ? "center" : "start" 
                        }}
                      >
                        {data[key]}
                      </TableCell>
                    )
                  ))}
                  <TableCell sx={{ fontSize: "18px", textAlign: "center" }}>
                    <Typography 
                      onClick={() => viewHandler(data)} 
                      sx={{ 
                        cursor: "pointer", 
                        "&:hover": { color: "#3E4094" }, 
                        fontSize: {lg: "18px", md: "14px"}, 
                        textDecoration: "underline" 
                      }}
                    >
                      {viewText || "View"}
                    </Typography>
                  </TableCell>
                </>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {pagination && <TablePagination
        rowsPerPageOptions={[10, 15, 20]}
        component="div"
        count={tableData.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />}
    </>
  )
}

export default CommonDataTable